import React, { FunctionComponent } from 'react';

import {
  InsuredItem,
  SingleFieldStepProps,
  YES_NO_DONT_KNOW_OPTIONS,
} from 'scenes/common/types';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';

const STATE_KEY = 'rewiredOrReplumbed';

const RewiredOrReplumbedStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext' | 'defaultStateValue'> & {
    insuredItem: InsuredItem;
  }
> = ({ onNext, defaultStateValue, insuredItem }) => {
  const question = `Has the ${insuredItem} been re-wired or re-plumbed?`;
  return (
    <SingleSegmentedControlStep
      onNext={onNext}
      question={question}
      stateKey={STATE_KEY}
      options={YES_NO_DONT_KNOW_OPTIONS}
      defaultStateValue={defaultStateValue}
    />
  );
};

export default RewiredOrReplumbedStep;
